export const ANY_THREAD = "Any";

export type MaxThreadSizeOption = {
  value: string;
  label: string;
};

/**
 * Keep the selector resilient to malformed or unexpectedly unordered API data.
 * The service normally returns DISTINCT integers in ascending order, but the
 * browser still validates that boundary before rendering it.
 */
export function normalizeMaxThreadSizes(values: readonly unknown[]): number[] {
  return Array.from(
    new Set(
      values.filter(
        (value): value is number =>
          typeof value === "number" &&
          Number.isFinite(value) &&
          Number.isInteger(value) &&
          value > 0,
      ),
    ),
  ).sort((left, right) => left - right);
}

export function buildMaxThreadSizeOptions(
  values: readonly unknown[],
): MaxThreadSizeOption[] {
  return [
    { value: ANY_THREAD, label: ANY_THREAD },
    ...normalizeMaxThreadSizes(values).map((size) => ({
      value: String(size),
      label: `M${size}`,
    })),
  ];
}
